const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/ampaiprivacy"],
    exact: true,
    component: "Privacy",
  },
];

export default routes;
